<!--<div class="container page_mar_t">
  <div class="row align-items-center">
    <div class="col-lg-6 col-md-12 ">
      <div class="main-banner-content">
        <div class="slider_sheap disply_n"><img src="../../../assets/img/website/shape-image-6.png" class="animation" alt="image"></div>
        <span> An ISO 9001 : 2015 certified company</span>
        <h1>Kamineni Life Sciences Pvt Ltd</h1>

        <p>
          Kamineni Life Sciences Private Limited, an ISO 9001:2008 Certified Company is
          a renowned manufacturer of Diagnostic. Our range of quality Diagnostic
          Kits and Medical Equipments includes reagents, rapids, Elisa, medical instruments,
          and other products. Our State-of-the-art infrastructure is as per WHO-GMP certified.
        </p>
        <a routerLink="" class="btn btn-primary">ENQUIRY</a>
      </div>
    </div>
    <div class="col-lg-6 col-md-12">
      <div class="banner-image">
        <img src="../../../assets/img/website/slider_image.png" style="width:114%;margin-bottom:5rem;margin-top:7rem;" class="animation animate__animated animate__bounce slider_image" alt="image">
      </div>
    </div>
  </div>
</div>-->
<script>
  $("#carousel-inner > div:gt(0)").hide();

  setInterval(function () {
    $('#carousel-inner > div:first')
      .fadeOut(1000)
      .next()
      .fadeIn(1000)
      .end()
      .appendTo('#carousel-inner');
  }, 3000);
</script>

<div>
  <div id="carouselExampleIndicators" data-interval="2000" class="carousel slide" data-ride="carousel" style="margin-top:4rem;margin-bottom:3rem;">
    <ol class="carousel-indicators">
      <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active">
      </li>
      <li data-target="#carouselExampleIndicators" data-slide-to="1" class="active"></li>
      <li data-target="#carouselExampleIndicators" data-slide-to="2" class="active"></li>
      <li data-target="#carouselExampleIndicators" data-slide-to="3" class="active"></li>
      <li data-target="#carouselExampleIndicators" data-slide-to="4" class="active"></li>
      <li data-target="#carouselExampleIndicators" data-slide-to="5" class="active"></li>
      <li data-target="#carouselExampleIndicators" data-slide-to="6" class="active"></li>
    </ol>
    <div class="carousel-inner">
      <div class="carousel-item slider_image_1 active">
        <!--<img src="../../../assets/img/kLSSLIDER1.jpeg" style="width:100%">-->
        <div class="slider_heading card-image ">
          Committed to High Quality Diagnostics
        </div>
        <div class="container">
          <br />
          <span class="subtxt">
            Kamineni Life Sciences is a world pioneer in the development of medical<br />
            devices for blood-based laboratory and Point of Care (POCT) testing for<br />
            hospital,professional, and self-testing applications.
          </span>
        </div>
        <!--<div style="margin-left:8.8em;margin-top:2rem;">  <a routerLink="/contact-us" class="btn btn-primary">ENQUIRY</a></div>-->
      </div>
      <div class="carousel-item slider_image_2">
        <!--<img src="../../../assets/img/Klsslider2.jpeg" style="width:100%">-->
        <div class="slider_heading card-image ">
          Redefining In-Vitro DiagnosticsS
        </div>
        <div class="container">
          <br />
          <span class="subtxt">
            With a unique fingerprint in structure and design, Kamineni Life Sciences<br />
            ensures top-quality products and high-quality customer service.
          </span>
        </div>
        <!--<div style="margin-left:8.8em;margin-top:2rem;">  <a routerLink="/contact-us" class="btn btn-primary">ENQUIRY</a></div>-->
      </div>
      <div class="carousel-item slider_image_3">
        <!--<img src="../../../assets/img/Klsslider3.jpeg" style="width:100%">-->
        <div class="slider_heading card-image">
          Better Diagnostics Today For A Better Life Tomorrow
        </div>
        <div class="container">
          <br />
          <span class="subtxt">
            Our goal is to supply advanced analytical and diagnostic analyzers<br />
            and hand-held devices to hospitals, pathological laboratories,<br />
            OEM clients, and patients.
          </span>
        </div>
        <!--<div style="margin-left:8.8em;margin-top:2rem;">  <a routerLink="/contact-us" class="btn btn-primary">ENQUIRY</a></div>-->
      </div>

      <div class="carousel-item slider_image_4">
        <!--<img src="../../../assets/img/Klsslider3.jpeg" style="width:100%">-->
        <div class="sub_slider_image card-image">
          <div class="product_box">
            <a style="cursor:pointer" (click)="productInfo(53)">
              <img src="../../../assets/img/Products/BA200.png" class="sub_product_image" />
            </a>
          </div>
        </div>
        <div class="container">
          <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
          <a style="cursor:pointer" (click)="productInfo(53)">
            <span class="subtxt">
              Efficient, Compact, Robust, User – friendly Aspiration Analyzer with<br />
              builtin stabilizer and Easy to use Software
              <!--Our goal is to supply advanced analytical and diagnostic analyzers<br />
          and hand-held devices to hospitals, pathological laboratories,<br />
          OEM clients, and patients.-->
            </span>
          </a>
        </div>
        <!--<div style="margin-left:8.8em;margin-top:2rem;">  <a routerLink="/contact-us" class="btn btn-primary">ENQUIRY</a></div>-->
      </div>

      <div class="carousel-item slider_image_4">
        <!--<img src="../../../assets/img/Klsslider3.jpeg" style="width:100%">-->
        <div class="sub_slider_image card-image">
          <div class="product_box">
            <a style="cursor:pointer" (click)="productInfo(2)">
              <img src="../../../assets/img/Products/COLORIMETER.png" class="sub_product_image" />
            </a>
          </div>
        </div>
        <div class="container">
          <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
          <a style="cursor:pointer" (click)="productInfo(2)">
            <span class="subtxt">
              The instrument can measure Absorbance, %T and concentration for<br />
              all the end point chemistries.

              <!--Our goal is to supply advanced analytical and diagnostic analyzers<br />
          and hand-held devices to hospitals, pathological laboratories,<br />
          OEM clients, and patients.-->
            </span>
          </a>
        </div>
        <!--<div style="margin-left:8.8em;margin-top:2rem;">  <a routerLink="/contact-us" class="btn btn-primary">ENQUIRY</a></div>-->
      </div>

      <div class="carousel-item slider_image_4">
        <!--<img src="../../../assets/img/Klsslider3.jpeg" style="width:100%">-->
        <div class="sub_slider_image card-image">
          <div class="product_box">
            <a style="cursor:pointer" (click)="productInfo(1106)">
              <img src="../../../assets/img/Products/OurProd3.jpg" class="sub_product_image" />
            </a>
          </div>
        </div>
        <div class="container">
          <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
          <a style="cursor:pointer" (click)="productInfo(1106)">
            <span class="subtxt">
              Fully Automatic, Discrete, Random Access, STAT sample priority.<br />
              Open System for User Defined Profiles and Calculations
              <!--Our goal is to supply advanced analytical and diagnostic analyzers<br />
  and hand-held devices to hospitals, pathological laboratories,<br />
  OEM clients, and patients.-->
            </span>
          </a>
        </div>
        <!--<div style="margin-left:8.8em;margin-top:2rem;">  <a routerLink="/contact-us" class="btn btn-primary">ENQUIRY</a></div>-->
      </div>

      <div class="carousel-item slider_image_4">
        <!--<img src="../../../assets/img/Klsslider3.jpeg" style="width:100%">-->
        <div class="sub_slider_image card-image">
          <div class="product_box">
            <a style="cursor:pointer" (click)="productInfo(1)">
              <img src="../../../assets/img/Products/OurProd5.png" class="sub_product_image" />
            </a>
          </div>
        </div>
        <div class="container">
          <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
          <a style="cursor:pointer" (click)="productInfo(1)">
            <span class="subtxt">
              Intelligent, Compact, Robust. Efficient Auto Electrolyte Analyzer with ISE Technology<br />
              Flexible Configuration Functionality available (Ionic Calcium)
              <!--Our goal is to supply advanced analytical and diagnostic analyzers<br />
  and hand-held devices to hospitals, pathological laboratories,<br />
  OEM clients, and patients.-->
            </span>
          </a>
        </div>
        <!--<div style="margin-left:8.8em;margin-top:2rem;">  <a routerLink="/contact-us" class="btn btn-primary">ENQUIRY</a></div>-->
      </div>
    </div>
    <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
  </div>
</div>

<section class="boxes-area">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-6 animate__animated animate__fadeInUp" style="cursor:pointer">
        <div class="single-box_1">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 width="40" height="40"
                 viewBox="0 0 172 172"
                 style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ffffff"><path d="M91.375,0c-2.96045,0 -5.375,2.41455 -5.375,5.375c0,2.96045 2.41455,5.375 5.375,5.375c2.96045,0 5.375,-2.41455 5.375,-5.375c0,-2.96045 -2.41455,-5.375 -5.375,-5.375zM75.25,16.125c-2.96045,0 -5.375,2.41455 -5.375,5.375h-16.125v10.75h5.375v41.15234l-33.08984,42.66406c-2.91846,3.7583 -4.53516,8.35645 -4.53516,13.10156c0,11.73682 9.59521,21.33203 21.33203,21.33203h86.33594c11.73682,0 21.33203,-9.59521 21.33203,-21.33203c0,-4.74511 -1.6167,-9.34326 -4.53516,-13.10156l-33.08984,-42.66406v-41.15234h5.375v-10.75h-37.625c0,-2.96045 -2.41455,-5.375 -5.375,-5.375zM69.875,32.25h32.25v44.84766l15.28516,19.65234h-62.82031l15.28516,-19.65234zM91.375,53.75c-2.96045,0 -5.375,2.41455 -5.375,5.375c0,2.96045 2.41455,5.375 5.375,5.375c2.96045,0 5.375,-2.41455 5.375,-5.375c0,-2.96045 -2.41455,-5.375 -5.375,-5.375zM46.19141,107.5h79.61719l11.75781,15.11719c1.44873,1.86865 2.18359,4.19922 2.18359,6.55078c0,5.9419 -4.64014,10.58203 -10.58203,10.58203h-86.33594c-5.9419,0 -10.58203,-4.64014 -10.58203,-10.58203c0,-2.35156 0.73486,-4.68213 2.18359,-6.55078z"></path></g></g></svg>
          </div>

          <h3>MISSION</h3>
          <p class="box_text">
            Introducing world-class products in the market to enhance accuracy in healthcare diagnostics.
          </p>
          <!--<p class="box_text">Introducing world-class products in the market to enhance accuracy in healthcare diagnostics.</p>
          <p class="box_text">Bringing excellent testing technology that facilitates medical diagnosis.</p>
          <p class="box_text">Establishing sustainable relationships with all our associates.</p>-->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6" style="cursor:pointer">
        <div class="single-box_2 bg-43c784">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 width="40" height="40"
                 viewBox="0 0 172 172"
                 style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ffffff"><path d="M21.5,7.16667c-7.83362,0 -14.33333,6.49972 -14.33333,14.33333v14.33333v7.16667h14.33333v-7.16667v-14.33333h14.33333h7.16667v-14.33333h-7.16667zM129,7.16667v14.33333h7.16667h14.33333v14.33333v7.16667h14.33333v-7.16667v-14.33333c0,-7.83362 -6.49972,-14.33333 -14.33333,-14.33333h-14.33333zM86,28.66667c-57.33333,0 -78.83333,57.33333 -78.83333,57.33333c0,0 21.5,57.33333 78.83333,57.33333c57.33333,0 78.83333,-57.33333 78.83333,-57.33333c0,0 -21.5,-57.33333 -78.83333,-57.33333zM86,43c37.81133,0 56.93626,30.58084 63.12826,42.97201c-6.19917,12.30517 -25.46742,43.02799 -63.12826,43.02799c-37.81133,0 -56.93626,-30.58084 -63.12826,-42.97201c6.20633,-12.30517 25.46742,-43.02799 63.12826,-43.02799zM86,57.33333c-15.83117,0 -28.66667,12.8355 -28.66667,28.66667c0,15.83117 12.8355,28.66667 28.66667,28.66667c15.83117,0 28.66667,-12.8355 28.66667,-28.66667c0,-15.83117 -12.8355,-28.66667 -28.66667,-28.66667zM86,71.66667c7.91917,0 14.33333,6.41417 14.33333,14.33333c0,7.91917 -6.41417,14.33333 -14.33333,14.33333c-7.91917,0 -14.33333,-6.41417 -14.33333,-14.33333c0,-7.91917 6.41417,-14.33333 14.33333,-14.33333zM7.16667,129v7.16667v14.33333c0,7.83362 6.49972,14.33333 14.33333,14.33333h14.33333h7.16667v-14.33333h-7.16667h-14.33333v-14.33333v-7.16667zM150.5,129v7.16667v14.33333h-14.33333h-7.16667v14.33333h7.16667h14.33333c7.83362,0 14.33333,-6.49972 14.33333,-14.33333v-14.33333v-7.16667z"></path></g></g></svg>
          </div>
          <h3>VISION</h3>
          <p class="box_text">
            Kamineni Life Sciences shall innovate and invent cost effective solutions through continuous....
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3 col-sm-6 offset-sm-3" style="cursor:pointer">
        <div class="single-box_3 bg-f59f00">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 width="40" height="40"
                 viewBox="0 0 172 172"
                 style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ffffff"><path d="M44.29,0c-6.65156,0 -12.04,5.38844 -12.04,12.04c0,6.14094 4.59563,11.19344 10.535,11.9325l8.385,15.3725c-0.80625,1.6125 -1.29,3.45344 -1.29,5.375c0,2.60688 0.84656,5.01219 2.2575,6.9875l-12.1475,22.36c-3.56094,0.37625 -6.665,2.2575 -8.6,5.0525h-9.46c-2.17687,-3.13094 -5.79156,-5.16 -9.89,-5.16c-5.6975,0 -10.46781,3.92375 -11.7175,9.245c-0.02688,0.1075 -0.08062,0.215 -0.1075,0.3225c-0.72563,1.81406 -0.645,3.84313 0.215,5.59c1.37063,5.14656 6.03344,8.9225 11.61,8.9225c4.09844,0 7.71313,-2.02906 9.89,-5.16h9.46c1.935,2.795 5.03906,4.67625 8.6,5.0525l12.04,22.36c-1.38406,1.96188 -2.15,4.4075 -2.15,6.9875c0,1.88125 0.51063,3.68188 1.29,5.2675l-8.4925,15.48c-5.89906,0.77938 -10.4275,5.81844 -10.4275,11.9325c0,6.65156 5.38844,12.04 12.04,12.04c6.65156,0 12.04,-5.38844 12.04,-12.04c0,-1.97531 -0.55094,-3.84312 -1.3975,-5.4825l8.2775,-15.265c3.56094,-0.37625 6.65156,-2.2575 8.6,-5.0525h28.38c1.96188,2.82188 5.09281,4.70313 8.7075,5.0525l8.9225,15.5875c1.89469,3.31906 6.14094,4.47469 9.46,2.58c3.31906,-1.89469 4.47469,-6.14094 2.58,-9.46l-8.9225,-15.5875c0.71219,-1.53187 1.1825,-3.25187 1.1825,-5.0525c0,-2.60687 -0.84656,-5.01219 -2.2575,-6.9875l12.1475,-22.36c3.56094,-0.37625 6.65156,-2.2575 8.6,-5.0525h9.46c2.17688,3.13094 5.79156,5.16 9.89,5.16c5.99313,0 10.91125,-4.36719 11.825,-10.105c0.41656,-1.33031 0.41656,-2.75469 0,-4.085c-1.00781,-5.64375 -5.89906,-9.89 -11.825,-9.89c-4.09844,0 -7.71312,2.02906 -9.89,5.16h-9.46c-1.94844,-2.795 -5.03906,-4.67625 -8.6,-5.0525l-12.04,-22.36c1.38406,-1.96187 2.15,-4.4075 2.15,-6.9875c0,-1.88125 -0.51062,-3.68187 -1.29,-5.2675l8.4925,-15.48c4.25969,-0.45687 7.82063,-3.06375 9.5675,-6.7725h26.23c2.48594,0.04031 4.78375,-1.26312 6.03344,-3.41312c1.26313,-2.13656 1.26313,-4.79719 0,-6.93375c-1.24969,-2.15 -3.5475,-3.45344 -6.03344,-3.41313h-28.7025c-2.16344,-2.10969 -5.11969,-3.44 -8.385,-3.44c-6.65156,0 -12.04,5.38844 -12.04,12.04c0,1.84094 0.44344,3.60125 1.1825,5.16l-8.385,15.5875c-3.56094,0.37625 -6.65156,2.2575 -8.6,5.0525h-28.4875c-1.94844,-2.75469 -4.95844,-4.67625 -8.4925,-5.0525l-8.2775,-15.1575c0.87344,-1.66625 1.3975,-3.58781 1.3975,-5.59c0,-6.65156 -5.38844,-12.04 -12.04,-12.04zM71.81,51.6h28.38c1.58563,2.28438 3.91031,3.9775 6.665,4.73l13.115,24.1875c-0.83312,1.63938 -1.29,3.52063 -1.29,5.4825c0,1.96188 0.45688,3.84313 1.29,5.4825l-13.115,24.1875c-2.75469,0.7525 -5.07937,2.44563 -6.665,4.73h-28.38c-1.58562,-2.28437 -3.91031,-3.9775 -6.665,-4.73l-13.115,-24.1875c0.83313,-1.63937 1.29,-3.52062 1.29,-5.4825c0,-1.96187 -0.45687,-3.84312 -1.29,-5.4825l13.115,-24.1875c2.75469,-0.7525 5.07938,-2.44562 6.665,-4.73z"></path></g></g></svg>
          </div>
          <h3>INFRASTRUCTURE</h3>
          <p class="box_text">
            The manufacturing facility of Kamineni Life Sciences at Hyderabad is an eco-friendly plant,
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<br />
<br />
<br />
<br />
<section class="about-area ptb-120 marginh_t_3">
  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-12 padding_l_0">
        <div class="about-image" style="text-align:center;">          
          <img src="../../../assets/img/website/Life_Science.svg" alt="image" class="about_image" style="width:70%;">
          <!--<img src="../../../assets/img/NewImages/klsslider3.jpg" alt="image" class="about_image" style="width:70%;">-->
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="about-content">
          <span>Overview</span>
          <h2>Kamineni Life Sciences</h2>
          <br />
          <div class="about_text over_b_l">
            An ISO 9001:2015 & 13485:2016 Certified Company.
          </div>
          <div class="about_text over_b_l">
            State-of-the-art infrastructure as per WHO-GMP standards.
          </div>
          <div class="about_text over_b_l">
            World-class manufacturing facility with 60,000 Sft. built-up area.
          </div>
          <div class="about_text over_b_l">
            Involved in Research & Development and Manufacturing of high-end Diagnostic Kits & Medical Equipment.
          </div>
          <div class="about_text over_b_l">
            Stringent quality control systems govern the entire manufacturing process, starting from selection of raw materials to finished products
          </div>
          <div class="about_text over_b_l">
            Prompt and effective technical support by an experienced team.
          </div>

          <br />

          <!--<div class="btn-box">
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-8 col-xs-8">
                <a routerLink="/about-us" class="btn btn-primary">READ MORE</a>
              </div>
              <div class="col-lg-8 col-md-8 col-sm-4 col-xs-4 padding_l_0 disply_n">

              </div>
            </div>
          </div>-->
        </div>
      </div>
    </div>
  </div>
  <div class="bg-shape1"><img src="../../../assets/img/website/bg-shape1.png" alt="image"></div>
  <div class="shape-img9"><img src="../../../assets/img/4.png" alt="image"></div>
</section>

<!--<section class="services-area ptb-120 pt-0">
  <div class="container">
    <div class="section-title">
      <span>Services</span>
      <div class="row">
        <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
          <h2>There is no Doubt To Get Your Service Over Year of Experience</h2>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <a routerLink="/Products" class="btn btn-secondary">
            MORE SERVICES
          </a>
        </div>
      </div>


    </div>
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="single-services-box">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 width="60" height="60"
                 viewBox="0 0 172 172"
                 style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#611633"><path d="M96.26625,17.15297c-0.1644,0.00393 -0.32831,0.01965 -0.49047,0.04703h-23.53578c-15.15815,0 -27.52,12.36185 -27.52,27.52c0,15.15815 12.36185,27.52 27.52,27.52h23.50219c0.37149,0.0614 0.75054,0.0614 1.12203,0h23.53578c15.15815,0 27.52,-12.36185 27.52,-27.52c0,-15.15815 -12.36185,-27.52 -27.52,-27.52h-23.50219c-0.20863,-0.03506 -0.42004,-0.05081 -0.63156,-0.04703zM72.24,24.08c0,1.89986 1.54014,3.44 3.44,3.44c1.89986,0 3.44,-1.54014 3.44,-3.44h13.76v41.28h-13.76c0,-1.89986 -1.54014,-3.44 -3.44,-3.44c-1.89986,0 -3.44,1.54014 -3.44,3.44c-11.34235,0 -20.47145,-9.04713 -20.62656,-20.3511c0.15011,1.78105 1.6392,3.15043 3.42656,3.1511c1.89986,0 3.44,-1.54014 3.44,-3.44c0,-1.89986 -1.54014,-3.44 -3.44,-3.44c-1.77558,-0.00088 -3.2601,1.34974 -3.42656,3.1175c0.17287,-11.28817 9.29553,-20.3175 20.62656,-20.3175zM99.76,24.08h20.64c11.43993,0 20.64,9.20007 20.64,20.64c0,11.43993 -9.20007,20.64 -20.64,20.64h-20.64zM65.36,30.96c-1.89986,0 -3.44,1.54014 -3.44,3.44c0,1.89986 1.54014,3.44 3.44,3.44c1.89986,0 3.44,-1.54014 3.44,-3.44c0,-1.89986 -1.54014,-3.44 -3.44,-3.44zM86,30.96c-1.89986,0 -3.44,1.54014 -3.44,3.44c0,1.89986 1.54014,3.44 3.44,3.44c1.89986,0 3.44,-1.54014 3.44,-3.44c0,-1.89986 -1.54014,-3.44 -3.44,-3.44zM75.68,41.28c-1.89986,0 -3.44,1.54014 -3.44,3.44c0,1.89986 1.54014,3.44 3.44,3.44c1.89986,0 3.44,-1.54014 3.44,-3.44c0,-1.89986 -1.54014,-3.44 -3.44,-3.44zM65.36,51.6c-1.89986,0 -3.44,1.54014 -3.44,3.44c0,1.89986 1.54014,3.44 3.44,3.44c1.89986,0 3.44,-1.54014 3.44,-3.44c0,-1.89986 -1.54014,-3.44 -3.44,-3.44zM86,51.6c-1.89986,0 -3.44,1.54014 -3.44,3.44c0,1.89986 1.54014,3.44 3.44,3.44c1.89986,0 3.44,-1.54014 3.44,-3.44c0,-1.89986 -1.54014,-3.44 -3.44,-3.44zM151.91094,89.38625c-0.6265,0.00933 -1.25104,0.06709 -1.87453,0.16797c-1.66263,0.26901 -3.29797,0.87114 -4.8039,1.82078l-38.18265,23.52906c-0.88137,-0.48191 -1.96201,-1.01405 -3.38625,-1.69985c-1.63659,-0.78804 -3.34803,-1.59207 -4.31344,-2.02906c-5.19678,-2.35007 -21.76491,-9.18861 -34.33953,-14.70734c-5.37929,-2.36068 -11.12871,-3.56719 -16.88422,-3.62141c-5.75551,-0.05421 -11.52208,1.04574 -16.94469,3.30563l-22.17859,9.23828c-1.16185,0.45418 -1.98682,1.5017 -2.156,2.73764c-0.16918,1.23594 0.34393,2.46663 1.34099,3.21633c0.99706,0.7497 2.32182,0.90093 3.4622,0.39524l22.17859,-9.23828c9.11368,-3.79815 19.37152,-3.69935 28.41359,0.26875c12.69562,5.57183 29.53441,12.53118 34.27235,14.67375c0.85091,0.38517 2.56947,1.19331 4.16562,1.96188c1.59616,0.76856 3.27383,1.61885 3.41313,1.69984c1.53487,0.89275 2.55312,2.49081 2.55312,4.41422c0,2.89239 -2.26761,5.16 -5.16,5.16c-0.40993,0 -0.79883,-0.04586 -1.16906,-0.13437c-0.00224,0 -0.00448,0 -0.00672,0c-0.08679,-0.02064 -2.80835,-0.78501 -6.10734,-1.7536c-3.29899,-0.96859 -7.48993,-2.21254 -11.61672,-3.44c-8.25358,-2.45493 -16.2325,-4.84422 -16.2325,-4.84422c-1.82008,-0.54547 -3.73774,0.48781 -4.2832,2.30789c-0.54547,1.82008 0.48781,3.73774 2.30789,4.2832c0,0 7.98408,2.38683 16.24594,4.84422c4.13093,1.2287 8.33004,2.47386 11.6436,3.44672c3.31036,0.97193 5.4177,1.60283 6.45,1.84765c0.89569,0.21417 1.82269,0.3225 2.76812,0.3225c6.60889,0 12.04,-5.43111 12.04,-12.04c0,-2.0369 -0.53198,-3.95124 -1.43781,-5.63703l36.78516,-22.66906c0.01124,-0.00666 0.02243,-0.01338 0.03359,-0.02016c2.879,-1.8155 6.58361,-0.97652 8.39844,1.90141c1.76283,2.79429 1.02594,6.38762 -1.69313,8.26406c-0.0432,0.02815 -0.08576,0.05728 -0.12765,0.08735l-54.26063,41.11203c-3.70388,2.80822 -8.55793,3.56341 -12.94031,2.0089l-40.07062,-14.20344c-9.26503,-3.82397 -19.86866,-2.53621 -27.95,3.39297l-11.98625,8.79485c-1.03182,0.71174 -1.59488,1.92834 -1.4697,3.17555c0.12519,1.24722 0.91881,2.32764 2.0715,2.82011c1.15269,0.49247 2.48201,0.31903 3.46976,-0.4527l11.98625,-8.78813c6.15338,-4.51466 14.19708,-5.49155 21.25141,-2.58c0.05546,0.02161 0.11147,0.04177 0.16797,0.06047l40.23188,14.26391c6.55681,2.32581 13.85419,1.1925 19.39703,-3.01l54.13297,-41.01797c5.69517,-3.93028 7.30098,-11.74254 3.60797,-17.59641c-2.49326,-3.95377 -6.8281,-6.10547 -11.2136,-6.04015z"></path></g></g></svg>
          </div>
          <h3>Pharmaceuticals Sector</h3>
          <p class="service_v_t">
            With more than 3 years of experience,
            Alta has been an active participant in
            the spectacular changes that have
            taken place in the chemical...
          </p>

        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="single-services-box">
          <div class="icon bg-24b765">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 width="60" height="60"
                 viewBox="0 0 172 172"
                 style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#611633"><path d="M65.36,20.64c-1.462,0 -2.76355,0.92509 -3.24515,2.30453c-0.4816,1.37944 -0.04021,2.91481 1.10187,3.82297c2.67976,2.13624 4.51,4.80616 5.58328,8.14985v56.89437l-33.56687,48.82515c-1.4448,2.10184 -1.60664,4.80821 -0.42328,7.06141c1.1868,2.26008 3.51455,3.66172 6.06703,3.66172h90.24625c2.55248,0 4.87695,-1.40508 6.06031,-3.66172c1.1868,-2.2532 1.02824,-4.95957 -0.41656,-7.06141l-33.56687,-48.82515v-57.20344c0.45408,-3.58792 2.00859,-5.89901 5.03235,-7.47797c1.40352,-0.73272 2.12855,-2.33232 1.75359,-3.87c-0.38184,-1.54112 -1.7601,-2.62031 -3.34594,-2.62031zM72.93875,27.52h25.35656c-1.02168,1.892 -1.67324,4.05823 -1.94844,6.49031c-0.0172,0.12728 -0.02687,0.25897 -0.02687,0.38969v58.48c0,0.69488 0.21253,1.3774 0.60469,1.94844l7.53172,10.95156h-36.91281l7.53172,-10.95156c0.38872,-0.57104 0.60469,-1.25356 0.60469,-1.94844v-58.48c0,-0.33024 -0.04822,-0.65774 -0.1411,-0.97422c-0.62952,-2.1328 -1.49935,-4.10322 -2.60015,-5.90578zM20.64,48.16c-1.90232,0 -3.44,1.54112 -3.44,3.44v18.34219c-10.44384,4.81944 -17.11744,14.91982 -17.2,26.35094c-0.06192,8.342 3.13481,16.16886 8.98969,22.0375c5.77232,5.77576 13.50555,8.94937 21.78219,8.94937h0.18813h4.45453l4.81062,-6.88h-9.28531h-0.14781c-6.45688,0 -12.46269,-2.45831 -16.93125,-6.93375c-4.54768,-4.55456 -7.02894,-10.63154 -6.98078,-17.11938c0.01752,-2.41569 0.40726,-4.73571 1.12203,-6.90687h46.49375c0.30684,1.1406 0.51833,2.30893 0.54422,3.5139c0.02064,1.02512 0.01016,4.87228 0.00672,6.25516l6.53735,-9.3525c-1.52736,-9.47376 -9.08966,-16.91803 -16.86406,-20.06219v-18.19437c0,-1.89888 -1.53768,-3.44 -3.44,-3.44zM116.96,48.16c-1.90232,0 -3.44,1.54112 -3.44,3.44v26.94219c-0.0614,0.37149 -0.0614,0.75054 0,1.12203v15.04328l6.67172,9.5339c0.10664,-0.33368 0.20828,-0.66988 0.20828,-1.0414v-20.64h37.84v37.84h-26.75406l4.81063,6.88h25.38344c1.90232,0 3.44,-1.54112 3.44,-3.44v-44.14219c0.0614,-0.37149 0.0614,-0.75054 0,-1.12203v-16.555c0.086,-2.89304 2.16548,-5.9748 4.945,-7.33015c1.43792,-0.70176 2.20541,-2.30152 1.84765,-3.86328c-0.3612,-1.56176 -1.74961,-2.66735 -3.35265,-2.66735zM24.08,55.04h13.76v17.2c0,1.53768 1.02018,2.88923 2.49937,3.31235c3.78801,1.07756 7.64245,3.6241 10.46781,7.00765h-38.96203c2.52628,-3.08985 5.88727,-5.57353 9.99078,-7.095c1.34504,-0.4988 2.24406,-1.78708 2.24406,-3.225zM120.4,55.04h39.79515c-1.18336,2.10872 -1.88635,4.47544 -1.95515,6.88v13.76h-37.84zM62.8136,112.66h46.37281l21.87625,31.82l-90.1589,0.05375z"></path></g></g></svg>
          </div>
          <h3>Laboratory & Research Sector</h3>
          <p class="service_v_t">
            The Laboratory is exploring new business
            fields that will grow to be core
            businesses in the future.
          </p>

        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="single-services-box">
          <div class="icon bg-f59f00">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 width="60" height="60"
                 viewBox="0 0 172 172"
                 style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#611633"><path d="M41.28,17.2c-5.6587,0 -10.32,4.6613 -10.32,10.32v4.13875c-5.86989,1.56986 -10.32,6.71929 -10.32,13.06125v45.74797c-3.49136,1.10676 -6.40885,3.04517 -8.59328,5.50266c-3.49712,3.93426 -5.16672,9.04493 -5.16672,14.10937c0,5.06444 1.6696,10.17511 5.16672,14.10937c2.18443,2.45748 5.10192,4.3959 8.59328,5.50266v18.22797h-17.2v6.88h158.24h6.88v-3.44v-3.44h-10.32v-65.36h-3.66172l-3.44,-51.6h-16.75656l-3.44,51.6h-13.98172h-6.88v-55.04c0,-5.6587 -4.6613,-10.32 -10.32,-10.32h-27.52h-3.44zM41.28,24.08h24.08v7.57875c-5.86989,1.56986 -10.32,6.71929 -10.32,13.06125v45.74797c-2.65193,0.84066 -4.95927,2.17391 -6.88,3.8364v-49.58437c0,-6.34196 -4.45011,-11.49139 -10.32,-13.06125v-4.13875c0,-1.9437 1.4963,-3.44 3.44,-3.44zM72.24,24.08h27.52c1.9437,0 3.44,1.4963 3.44,3.44v55.04h-20.64v-37.84c0,-6.34196 -4.45011,-11.49139 -10.32,-13.06125zM34.4,37.84c3.84133,0 6.88,3.03867 6.88,6.88v17.2h-13.76v-17.2c0,-3.84133 3.03867,-6.88 6.88,-6.88zM68.8,37.84c3.84133,0 6.88,3.03867 6.88,6.88v17.2h-13.76v-17.2c0,-3.84133 3.03867,-6.88 6.88,-6.88zM140.81828,37.84h3.88344l3.44,51.6h3.21828v58.48h-68.8v-37.84v-20.64h34.4h20.41828h3.66172v-6.88h-3.20485zM27.52,68.8h13.76v25.95453c-3.65935,-3.29037 -8.47748,-5.31453 -13.76,-5.31453zM61.92,68.8h13.76v25.95453c-3.65935,-3.29037 -8.47748,-5.31453 -13.76,-5.31453zM27.52,96.32c7.64019,0 13.76,6.11981 13.76,13.76c0,7.64019 -6.11981,13.76 -13.76,13.76c-4.87333,0 -8.09051,-1.70364 -10.32672,-4.21937c-2.23621,-2.51574 -3.43328,-6.00507 -3.43328,-9.54063c0,-3.53556 1.19707,-7.02489 3.43328,-9.54063c2.23621,-2.51573 5.45339,-4.21937 10.32672,-4.21937zM61.92,96.32c7.64019,0 13.76,6.11981 13.76,13.76c0,7.64019 -6.11981,13.76 -13.76,13.76c-4.87333,0 -8.09051,-1.70364 -10.32672,-4.21937c-2.23621,-2.51574 -3.43328,-6.00507 -3.43328,-9.54063c0,-3.53556 1.19708,-7.02489 3.43328,-9.54063c2.23621,-2.51573 5.45339,-4.21937 10.32672,-4.21937zM89.44,99.76v6.88h13.76v-6.88zM110.08,99.76v6.88h13.76v-6.88zM130.72,99.76v6.88h13.76v-6.88zM41.28,125.40547v22.51453h-13.76v-17.2c5.28252,0 10.10065,-2.02416 13.76,-5.31453zM75.68,125.40547v22.51453h-13.76v-17.2c5.28252,0 10.10065,-2.02416 13.76,-5.31453zM48.16,125.85563c1.92073,1.6625 4.22807,2.99574 6.88,3.8364v18.22797h-6.88z"></path></g></g></svg>
          </div>
          <h3>Industries Sector</h3>
          <p class="service_v_t">
            The industry is advancing with new
            chemistry, new technology, and expanding
            capacity.
          </p>

        </div>
      </div>
    </div>
  </div>
</section>-->

<br /><br /><br />

<section class="services-area ptb-120 pt-0">
  <div class="container">
    <div class="section-title">
      <span>OUR PRODUCTS</span>
      <div class="row">
        <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
          <h2>
            OUR PRODUCTS
          </h2>
          <!--<p class="more_card_text">
            With more than 3 years of experience, Alta has been an active participant in the spectacular changes that have taken place in the chemical and pharmaceutical industries.

          </p>-->
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <a routerLink="/Products" class="btn btn-secondary">
            MORE PRODUCTS
          </a>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <!--<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12" *ngFor="let item of ProductsList; let i=index">
    <div *ngIf="i>3&&i<8">
      <a routerLink="/Products">
        <div class="product_box">
          <img src="{{HomeURL+item.Image1}}" class="product_image" />
        </div>
        <div class="product_heading">
          {{item.Catalog_No}} | {{item.ChemicalName}}
        </div>
      </a>
      </div>
  </div>-->

      <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
        <a style="cursor:pointer" (click)="productInfo(53)">
          <div class="product_box">
            <img src="../../../assets/img/Products/OurProd1.jpeg" class="product_image" />
          </div>
          <div class="product_heading">
            BA 200 - LifeLAB - Biochemistry Analyser
          </div>
          </a>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
        <a style="cursor:pointer" (click)="productInfo(2)">
          <div class="product_box">
            <img src="../../../assets/img/Products/OurProd2.jpeg" class="product_image" />
          </div>
          <div class="product_heading">
            CL-1001 | Lifelab - Colorimeter
          </div>
          </a>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
        <a style="cursor:pointer" (click)="productInfo(1106)">
          <div class="product_box">
            <img src="../../../assets/img/Products/OurProd3.jpg" class="product_image" />
          </div>
          <div class="product_heading">
            LifeLab AUTOCHEM 200 T (Fully Auto Biochemistry Analyzer) (200T/Hr)
          </div>
          </a>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
        <a style="cursor:pointer" (click)="productInfo(1)">
          <div class="product_box">
            <img src="../../../assets/img/Products/OurProd4.jpg" class="product_image" />
          </div>
          <div class="product_heading">
            EA-300 - Lifelab Lifelyte Electrolyte Analyzer(EA-300)
          </div>
          </a>
</div>

    </div>

  </div>
</section>

<br /><br /><br /><br />




<div class="container-fluid more_bg">
  <div class="row">
    <div class="more_heading"> CERTIFICATES</div>
    <div class="more_sub_heading">
    
    </div>
  </div>
</div>

<div class="container">
  <div class="row">
    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
      <div class="more_card">
        <div class="text_align_c">
          <div>
            <img src="../../../assets/img/website/ec-logo.png" />
          </div>
        </div>

        <a  href="../../../assets/img/Certificates/CE.pdf" target="_blank" class="more_card_heading">CE CERTIFICATIONS</a>

      </div>
    </div>

    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
      <div class="more_card">
        <div class="text_align_c">
          <div>

            <img src="../../../assets/img/website/perry_logo.JPG" />
          </div>
        </div>

        <a href="../../../assets/img/Certificates/URS.pdf" target="_blank" class="more_card_heading">URS CERTIFICATIONS</a>

      </div>
    </div>

    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
      <div class="more_card more_card_1">
        <div class="text_align_c">
          <div>
            <img src="../../../assets/img/website/iqcs.png" />
          </div>
        </div>
        <a href="../../../assets/img/Certificates/ISO 13485.pdf" target="_blank" class="more_card_heading">ISO CERTIFICATIONS</a>

      </div>
    </div>
  </div>
</div>


<br /><br /><br /><br />

<div class="container-fluid contact_bg">
  <div class="row">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <!--<div class="mail_heading">Subscribe to our Newsletter</div>-->
          <div class="mail_heading">Drop us message for any query</div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <!--<div class="input-group text_box">
            <input type="email" [(ngModel)]="Email" class="form-control input_email" placeholder="Enter your email">
            <span class="input-group-btn">
              <button class="btn btn-theme sub_button" (click)="Subscribers(Email)" type="submit">Subscribe</button>
            </span>
          </div>-->
          <div class="input-group text_box">
            <span class="input-group-btn">
              <button style="margin-left:200px" class="btn btn-theme sub_button" routerLink="/contact-us" type="submit">Enquiry</button>
            </span>
          </div>


          <div class="inner-column margin_l_10">
            <!-- Phone -->
            <a href="tel:+91-756-904-1276" class="phone">
              <div class="row">
                <div class="col-lg-1 col-md-1 col-sm-12 col-xs-12">
                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                       width="80" height="80"
                       viewBox="0 0 172 172"
                       style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ffffff"><path d="M86,17.2c-37.92867,0 -68.8,30.87133 -68.8,68.8c0,37.92867 30.87133,68.8 68.8,68.8c37.92867,0 68.8,-30.87133 68.8,-68.8c0,-23.73438 -12.05195,-44.71912 -30.39114,-57.08698l6.57317,-8.43203l-27.78203,-1.00781l8.01771,26.39349l6.09167,-7.82734c14.14118,9.24449 23.956,24.50679 25.71041,42.23854c-3.03904,0.16645 -5.4184,2.67854 -5.41979,5.72214c0.00232,3.05592 2.40111,5.57292 5.45339,5.72214c-2.67683,27.14387 -24.18738,48.65442 -51.33125,51.33125c-0.14921,-3.05228 -2.66621,-5.45106 -5.72214,-5.45339c-3.05592,0.00232 -5.57292,2.40111 -5.72214,5.45339c-27.14387,-2.67683 -48.65442,-24.18738 -51.33125,-51.33125c3.05228,-0.14921 5.45106,-2.66621 5.45339,-5.72214c-0.00797,-3.04748 -2.39863,-5.55619 -5.44219,-5.71094c2.70158,-26.98721 24.35527,-47.73201 51.40963,-50.4914c0.55646,2.91575 3.24623,4.92475 6.20002,4.63083c2.95378,-0.29392 5.19491,-2.79359 5.16587,-5.76182v-5.73333c-0.00032,-3.1663 -2.56703,-5.73302 -5.73333,-5.73333zM67.44505,67.33308c-8.43947,0 -14.08698,4.88068 -14.08698,12.11614v0.14557h8.46562v-0.16796c0,-2.99853 2.16075,-5.11745 5.28542,-5.11745c2.99853,-0.00001 4.97188,1.78503 4.97188,4.45677c0,2.13853 -1.36409,3.98834 -6.70755,8.92474l-11.48906,10.80599v6.18124h27.64766v-7.21146h-15.31875v-0.47031l5.99089,-5.53177c6.45,-5.7448 8.82396,-9.31738 8.82396,-13.34792c0,-6.42133 -5.44747,-10.78359 -13.58307,-10.78359zM101.27396,68.30729c-6.27227,9.52307 -10.44864,16.40217 -13.75104,22.73177v7.73776h17.83828v5.8901h8.74558v-5.8901h4.53515v-7.21146h-4.53515v-23.25808zM105.13724,74.91406h0.45911v16.97604h-10.08933v-0.44792c4.08213,-7.61387 6.52848,-11.74653 9.63021,-16.52813z"></path></g></g></svg>
                </div>
                <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
                  <span class="call">Call Us Now</span>
                </div>
              </div>
              <strong class="call_number"> +91 7569041276 </strong>
              <!--<strong class="call_number"> +91 040-2724 1734 </strong>-->
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



